import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Context } from "../.."
import RubbleIcon from "../../components/icons/RubbleIcon";
import GlobalModal from "../../components/modals/GlobalModal";
import {ApiService} from "../../core/api/api";
import {useFetching} from "../../core/hooks/useFetching";
import useWindowDimensions from "../../core/hooks/useWindowDimensions";
import { Swiper, SwiperSlide, SwiperRef } from 'swiper/react';

import { BranchM, BranchModel, Region } from "../../core/models/Branch";
import {isElementInViewport, isNullOrUndefined, translateName, translit, translitName} from "../../core/utils/utils";

import styles from "../../styles/Branch.module.scss";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import LangSwitcher from "../../components/LangSwitcher";
import {FormattedMessage} from "react-intl";
import {LOCALES} from "../../core/i18n/locales";

const BranchPage: FC = () => {

  const { store } = useContext(Context)
  const { width, height } = useWindowDimensions()

  const navigate = useNavigate()
  const params: any = useParams()

  const swiperElRef = useRef(null as any)
  const swiperElRef2 = useRef(null as any)
  
  const [brancRgData, setBranchRgData] = useState(null as Region | null);
  const [branchData, setBranchData] = useState(null as BranchM | null);
  const [serviceTab, setServiceTab] = useState("haircut" as "haircut" | "beard" | "fh_care");

  const [swiper, setSwiper] = useState({} as any);
  const [swiperIndex, setSwiperIndex] = useState(0);
  
  const [orderVisible, setOrderVisible] = useState(false)
  const [orderUrl, setOrderUrl] = useState("")

  const [fetchBranches, isBranchesLoading, errBrn] = useFetching(async () => {
    const res = await ApiService.branches.getAll();

    console.log(params);

    let item: any = null;
    let itemRg: Region | null = null;
    res.data.branches.forEach((el: BranchModel) => {
      if (el.regions != undefined) {
        el.regions.forEach((rg) => {
          if (!isNullOrUndefined(params.rid)) {
            if (rg.id == params.rid) {
              itemRg = rg;
              rg.items.forEach((rrg) => {
                if (rrg.id == params.id) {
                  item = rrg;
                }
              });
            }
          } else if (!isNullOrUndefined(params.name)) {
            console.log(
              translit(rg.region.toLowerCase()),
              params.name.toLowerCase()
            )
            if (translit(rg.region.toLowerCase()) == params.name.toLowerCase()) {
              item = rg.items[0]
            } else {
              rg.items.forEach((rrg) => {
                if (
                  translit(rrg.title.toLowerCase()) == params.name.toLowerCase() || 
                  rrg.symlink == params.name.toLowerCase()
                ) {
                  item = rrg;
                }
              });
            }
          }
        });
      }
    });
    
    if (item == null) {
      navigate("/")
    } else {
      console.log(item, translit(item!.title.toLowerCase()))
    
      item.images = []
      item.about.split(";").forEach((image: string) => {
        if (image != "" && image != null) {
          item.images.push(image)
        }
      })

      setBranchData(item)
      setBranchRgData(itemRg)

      setTimeout(() => {
        runAnimations()
      }, 300)
    }
    
  })

  const runOpacity = (el: HTMLElement | null, delay: number = 0, asc: number = 0) => {
    if (el != null) {
      if (isElementInViewport(el)) {
        let dell = window.innerHeight - ((el.getBoundingClientRect().y + el.getBoundingClientRect().height) - delay + asc);
        el.style.opacity = `${(dell) / 100}`;
      } else {
        el.style.opacity = `0`;
      }
    }
  }
  
  const openOrder = (barber: any) => {
    let link = barber == null || barber.booking_link == undefined || barber.booking_link == "" ? (branchData != null && branchData.order_url != "" && branchData.order_url != "#" ? branchData.order_url : "https://n46407.yclients.com/?gcid=280852571.1688302143") : barber.booking_link

    if (width > 768) {
      setOrderUrl(prev => prev = link)
      setOrderVisible(prev => prev = true)
    } else {
      window.open(link, "_blank")
    }
  }

  const runLeftOpacity = (el: HTMLElement | null, delay: number = 0) => {
    if (el != null) {
      if (isElementInViewport(el)) {
        let dell = window.innerHeight - ((el.getBoundingClientRect().y + el.getBoundingClientRect().height) - delay);
        el.style.opacity = `${(dell) / 100}`;
        let ix = ((dell) / 4) - 100;
        if (ix < 0) {
          el.style.left = `${ix}px`;
        } else {
          el.style.left = `0px`;
        }
      } else {
        el.style.opacity = `0`;
        el.style.left = `-100px`;
      }
    }
  }

  const runBottomOpacity = (el: HTMLElement | null, delay: number = 0) => {
    if (el != null) {
      if (isElementInViewport(el)) {
        let dell = window.innerHeight - ((el.getBoundingClientRect().y + el.getBoundingClientRect().height) - delay);
        el.style.opacity = `${(dell) / 50}`;
        let ix = ((dell) / 4) - 50;
        if (ix < 0) {
          el.style.bottom = `${ix}px`;
        } else {
          el.style.bottom = `0px`;
        }
      } else {
        el.style.opacity = `0`;
        el.style.bottom = `-50px`;
      }
    }
  }

  const sortedBarbers = (barbers: any[]) => {
    return barbers.sort((a: any, b: any) => {
      let aa: any = parseInt(a.priority)
      let bb: any = parseInt(b.priority)
      if (`${aa}` == "NaN") {
        aa = 0
      }
      if (`${bb}` == "NaN") {
        bb = 0
      }
      console.log("sort", aa, bb)
      return aa > bb ? 1 : (aa < bb ? -1 : 0)
    })
  }

  const getCurrency = () => {
    if (branchData != null) {
      if (branchData.branch_region_id == 264) {
        return "Br"
      } else if (branchData.branch_region_id == 267) {
        return "AED"
      } else if (branchData.branch_region_id == 268) {
        return "Soʻm"
      } else if (branchData.branch_region_id == 266) {
        return "֏"
      } else {
        return <RubbleIcon />
      }
    } else {
      return <RubbleIcon />
    }
  }

  const runAnimations = () => {
    setTimeout(() => {
      const ttlAnim = document.getElementById("ttlAnim")
      const subTtlAnim = document.getElementById("subTtlAnim")
      const bgAnim = document.getElementById("bgAnim")
      const pb1 = document.getElementById("pb1")
      const pb2 = document.getElementById("pb2")
      
      const actAnim1 = document.getElementById("actAnim1")
      const actAnim2 = document.getElementById("actAnim2")
      const actAnim3 = document.getElementById("actAnim3")

      const langsw7 = document.getElementById("langsw7")

      console.log(ttlAnim,
        subTtlAnim,
        pb1,
        pb2,
        actAnim1,
        actAnim2,
        actAnim3,
        bgAnim,
        langsw7)

        if (actAnim3 != null) {
          setTimeout(() => {
            actAnim3.style.opacity = "1"
          }, 800)
        }

      if (
        ttlAnim != null &&
        subTtlAnim != null &&
        pb1 != null &&
        pb2 != null &&
        actAnim1 != null &&
        actAnim2 != null &&
        
        bgAnim != null && 
        langsw7 != null
      ) {
        ttlAnim.style.opacity = "1"
        ttlAnim.style.bottom = "0px"
        langsw7.style.opacity = "1"
        setTimeout(() => {
          pb2.style.opacity = "1"
          setTimeout(() => {
            pb1.style.opacity = "1"
          }, 200);
        }, 100);
        
        setTimeout(() => {
          subTtlAnim.style.opacity = "1"
          bgAnim.style.opacity = "1"
          setTimeout(() => {
            actAnim1.style.opacity = "1"
            setTimeout(() => {
              actAnim2.style.opacity = "1"
              setTimeout(() => {
                // actAnim3.style.opacity = "1"
              }, 100);
            }, 100);
          }, 200)
        }, 300);
      }
    }, 300)
  }

  useEffect(() => {
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
    
    store.setAnimationToggle(true)

    fetchBranches()

    const onScroll = (event: any) => {
      const scrollTop = event.target.scrollingElement.scrollTop;

      const servTtlAnim = document.getElementById("servTtlAnim")
      const servSubTtlAnim = document.getElementById("servSubTtlAnim")
      const servTabsAnim = document.getElementById("servTabsAnim")
      const tableHeadAnim = document.getElementById("tableHeadAnim")
      const st_11 = document.getElementById("st_11")
      const tableRow0 = document.getElementById("tableRow0")
      const tableRow1 = document.getElementById("tableRow1")
      const tableRow2 = document.getElementById("tableRow2")
      const tableRow3 = document.getElementById("tableRow3")
      const tableRow4 = document.getElementById("tableRow4")
      const tableRow5 = document.getElementById("tableRow5")
      const tableRow6 = document.getElementById("tableRow6")
      const tableRow7 = document.getElementById("tableRow7")
      const tableRow8 = document.getElementById("tableRow8")
      const tableRow9 = document.getElementById("tableRow9")
      const tableRow10 = document.getElementById("tableRow10")
      const tableRow11 = document.getElementById("tableRow11")
      const tableRow12 = document.getElementById("tableRow12")
      const tableRow13 = document.getElementById("tableRow13")
      const tableRow14 = document.getElementById("tableRow14")

      const actAnim1 = document.getElementById("actAnim1")
      const actAnim2 = document.getElementById("actAnim2")
      const actAnim3 = document.getElementById("actAnim3")
      const actAnim4 = document.getElementById("actAnim4")

      const ab_ttl = document.getElementById("ab_ttl")
      const ab_line = document.getElementById("ab_line")
      const ab_t1 = document.getElementById("ab_t1")
      const ab_t2 = document.getElementById("ab_t2")

      const bttl = document.getElementById("bttl")
      const blst = document.getElementById("blst")

      runBottomOpacity(bttl)
      runOpacity(blst, 200)

      runBottomOpacity(ab_ttl)
      runOpacity(ab_t1)
      runOpacity(ab_t2, -30)

      if (ab_line != null) {
        if (isElementInViewport(ab_line)) {
          let dell = window.innerHeight - ((ab_line.getBoundingClientRect().y + ab_line.getBoundingClientRect().height))
          ab_line.style.width = `${dell * 3}px`
        }
      }

      runBottomOpacity(servTtlAnim)
      runOpacity(servSubTtlAnim, -60)
      runOpacity(servTabsAnim, -40)
      runOpacity(tableHeadAnim)
      
      if (width > 768) {
        runLeftOpacity(st_11, 200);
      } else {
        runLeftOpacity(st_11, 200);
      }

      runOpacity(tableRow0)
      runOpacity(tableRow1)
      runOpacity(tableRow2)
      runOpacity(tableRow3)
      runOpacity(tableRow4)
      runOpacity(tableRow5)
      runOpacity(tableRow6)
      runOpacity(tableRow7)
      runOpacity(tableRow8)
      runOpacity(tableRow9)
      runOpacity(tableRow10)
      runOpacity(tableRow11)
      runOpacity(tableRow12)
      runOpacity(tableRow13)
      runOpacity(tableRow14)

      runOpacity(actAnim1)
      runOpacity(actAnim2, -20)
      runOpacity(actAnim3, -40)
      runOpacity(actAnim4, -60)
    }

    document.addEventListener('scroll', onScroll)

    return () => {
      document.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <>
      <div style={{}} className={styles.page_blink + "" + " " + styles.right + " " + styles.toped3} id="pb1"></div>

      <div className={styles.page_blink + " " + styles.reddz + " " + styles.toped} id="pb2"></div>

      <div className={styles.section_top} style={{
        opacity: isBranchesLoading ? "0" : "1"
      }}>
        {branchData != null ? <>
          <div className="container">
            <div className="row">
              <div className={"col-12 " + styles.posrel}>
                <div className={styles.lang} id="langsw7" style={{opacity: "0"}}><LangSwitcher /></div>
                <div className={styles.blockedd}>
                  <h1 className={styles.main_title} id="ttlAnim">{store.locale == LOCALES.RUSSIAN ? branchData.title : translitName(branchData.title)}</h1>
                  <h2 className={styles.sub_title} id="subTtlAnim">{store.locale == LOCALES.RUSSIAN ? branchData.address : translitName(branchData.address!)}</h2>
                </div>
              </div>
            </div>
          </div>

              <div id="bgAnim" style={{
                opacity: 0,
                transition: "all 0.8s ease",
                position: "relative"
              }}>
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <Swiper
                        ref={swiperElRef2}
                        style={{ transition: "all 0.3s ease", opacity: 1 }}
                        slidesPerView={1}
                        initialSlide={0}
                        onSlideChange={() => {
                          let llg = swiperElRef2.current.swiper.activeIndex
                          console.log(llg)
                          store.setSwiperIndex(llg)}}
                        onSwiper={(swiper) => setSwiper(swiper)}>
                        {branchData != null && branchData.images != undefined && branchData.images.length > 0 ? branchData.images.map((item: any) => <SwiperSlide>
                          <div className={styles.main_bg} style={{
                            backgroundImage: `url(${item})`
                          }}></div>
                        </SwiperSlide>) : <><SwiperSlide>
                          <div className={styles.main_bg} style={{backgroundPosition: "center", backgroundImage: `url(/assets/images/blog/ph_bg.png)`}}></div>  
                        </SwiperSlide></>}
                      </Swiper>
                    </div>
                  </div>
                </div>
                <div className={styles.mat_sl_pag} id="b_act_pag" style={{top: width > 960 ? "52%" : ""}}>
                  <div>
                    <button onClick={() => swiperElRef2.current.swiper.slidePrev()} style={{
                      transition: "all 0.3s ease",
                      opacity: store.swiperIndex == 0 ? "0.3" : "1"
                    }}><i className="far fa-chevron-left"></i></button>
                    <button onClick={() => swiperElRef2.current.swiper.slideNext()} style={{
                      transition: "all 0.3s ease",
                      opacity: store.swiperIndex == (branchData.images!.length - 1) ? "0.3" : "1"
                    }}><i className="far fa-chevron-right"></i></button>
                  </div>
                </div>
              </div>

          <div className="container">
            <div className="row">
            <div className={"col-12 " + styles.posrel}>
              <div className={styles.actions}>
                <a id="actAnim1" href={branchData.order_url} onClick={(evt) => {
                  evt.preventDefault()
                  evt.stopPropagation()
                  openOrder(null)
                }} target="_blank"><FormattedMessage id="sign_up_client" /></a>
                <a id="actAnim2" href={`tel:${branchData.phone}`}><FormattedMessage id="call_bbs" /></a>
                {branchData.maps_url != "" && branchData.maps_url != "#" ? <a id="actAnim3" href={branchData.maps_url} target="_blank"><FormattedMessage id="on_maps" /></a> : <></>}
              
                {width > 1280 ? <a id="actAnim4" href={`tel:${branchData.phone}`}>{branchData.phone}</a> : <></>}
              </div>

              {branchData.about_content != "" && branchData.status_aboutus == 1 ? <div className={styles.about_branch}>
                <div className={styles.ab_title} id="ab_ttl"><FormattedMessage id="branch_about_ttl" /></div>
                <div className={styles.ab_content} style={{
                  maxWidth: store.locale == "ru-RU" ? "89%" : "85%"
                }}>
                  <div className={styles.line} id="ab_line"></div>
                  <div className={styles.txts}>
                    <div id="ab_t1" dangerouslySetInnerHTML={{__html: `${store.locale == LOCALES.RUSSIAN ? branchData.about_content : translitName(branchData.about_content!)}`}}></div>
                  </div>
                </div>
              </div> : <></>}

              <div className={styles.services}>
                <h3 id="servTtlAnim"><FormattedMessage id="branch_servs_ttl" /></h3>
                {brancRgData != null ? <h4 id="servSubTtlAnim">{brancRgData.region}</h4> : <></>}
                <div className={styles.services_tabs} id="servTabsAnim">
                  <div onClick={() => setServiceTab("haircut")} className={serviceTab == "haircut" ? styles.active : ""}><FormattedMessage id="home_services_i1" /></div>
                  <div onClick={() => setServiceTab("beard")} className={serviceTab == "beard" ? styles.active : ""}><FormattedMessage id="home_services_i2" /></div>
                  <div onClick={() => setServiceTab("fh_care")} className={serviceTab == "fh_care" ? styles.active : ""}><FormattedMessage id="home_services_i3" /></div>
                </div>

                <div className={styles.services_table}>
                  <div className={styles.services_table__row + " " + styles.services_table__head} id="tableHeadAnim">
                    <div id="st_11" className={styles.xxx}><span style={{backgroundImage: `url(/assets/images/${width <= 768 ? "arrow_line_mob" : "arrow_line"}.png)`}}></span></div>
                    {/* <div>barber</div>
                    <div>pro barber</div>
                    <div>top barber</div> */}
                    <div className={styles.xsxph}>
                      {branchData.services[`haircutStates`].barber ? <div>barber</div> : <></>}
                      {branchData.services[`haircutStates`].probarber ? <div>pro{width > 768 ? " barber" : ""}</div> : <></>}
                      {branchData.services[`haircutStates`].topbarber ? <div>top{width > 768 ? " barber" : ""}</div> : <></>}
                      {branchData.services[`haircutStates`].elite ? <div>{width > 768 ? "individual" : "ind"}</div> : <></>}
                    </div>
                  </div>
                  {branchData != null && branchData.services[serviceTab] != undefined ? branchData.services[serviceTab].map((service: any, ix: number) => <div className={styles.services_table__row} id={`tableRow${ix}`}>
                    <div>{store.locale == LOCALES.RUSSIAN ? service.title : translateName(service.title)}</div>
                    <div className={styles.xsxp}>
                      {branchData.services[`haircutStates`].barber ? <div>{service.barber}</div> : <></>}
                      {branchData.services[`haircutStates`].probarber ? <div>{service.probarber} {!branchData.services[`haircutStates`].elite && !branchData.services[`haircutStates`].topbarber ? <span style={{display: width > 768 ? "contents" : "contents"}}>{getCurrency()}</span> : <></>}</div> : <></>}
                      {branchData.services[`haircutStates`].topbarber ? <div>{service.topbarber} {!branchData.services[`haircutStates`].elite ? <span style={{display: width > 768 ? "contents" : "none"}}>{getCurrency()}</span> : <></>}</div> : <></>}
                      {branchData.services[`haircutStates`].elite ? <div>{service.elite} <span style={{display: width > 768 ? "contents" : "none"}}>{getCurrency()}</span></div> : <></>}
                    </div>
                  </div>) : <></>}
                </div>
              </div>

              <div className={styles.barbers} style={{display: branchData.status_barbers == 1 ? "block" : "none"}}>
                <h2 id="bttl"><FormattedMessage id="branch_brbrs" /></h2>
                <div className={styles.barbers_wrap} id="blst">
                  <div className={styles.barbers_list}>
                    <Swiper
                      ref={swiperElRef}
                      style={{ transition: "all 0.3s ease", opacity: 1, overflow: "unset" }}
                      slidesPerView={width > 1240 ? 4 : (width > 960 ? 2 : "auto")}
                      initialSlide={0}
                      className={styles.myswp + " myswpp"}
                      spaceBetween={width > 1240 ? 30 : (width > 960 ? 20 : 8)}
                      onSlideChange={() => {
                        let llg = swiperElRef.current.swiper.activeIndex
                        console.log(llg)
                        store.setSwiperIndexA(llg)}}
                      onSwiper={(swiper) => setSwiper(swiper)}>
                      {sortedBarbers(branchData.barbers).map((barber: any) => <SwiperSlide><div className={styles.barbers_list__item}>
                        <div className={styles.bli_image}>
                          <div style={{backgroundImage: `url(${barber.avatar_big})`}}></div>
                        </div>
                        <div className={styles.bli_data}>
                          <div className={styles.bli_name}>{store.locale == LOCALES.RUSSIAN ? barber.name : translitName(barber.name)}</div>
                          <div className={styles.bli_rank}>{barber.specialization}</div>
                          <div className={styles.bli_payroll}>{barber.rating != "" ? <><FormattedMessage id="branch_barber_reviews" />: {barber.rating}</> : <></>}</div>
                        </div>
                        <div className={styles.bli_action}>
                          <button onClick={() => openOrder(barber)}><FormattedMessage id="home_h1_btn" /></button>
                        </div>
                      </div></SwiperSlide>)}
                    </Swiper>

                  </div>
                  <div className={styles.mat_sl_pag} id="b_act_pag" style={{top: width > 960 ? "40%" : ""}}>
                    <div>
                      <button onClick={() => swiperElRef.current.swiper.slidePrev()} style={{
                        transition: "all 0.3s ease",
                        opacity: store.swiperIndexA == 0 ? "0.3" : "1"
                      }}><i className="far fa-chevron-left"></i></button>
                      <button onClick={() => swiperElRef.current.swiper.slideNext()} style={{
                        transition: "all 0.3s ease",
                        opacity: (width > 768 ? store.swiperIndexA + 3 : (store.swiperIndexA == branchData.barbers!.length - 2 ? store.swiperIndexA - 1 : store.swiperIndexA - 1)) == (branchData.barbers!.length - 1) ? "0.3" : "1"
                      }}><i className="far fa-chevron-right"></i></button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div></> : <></>}
      </div>

      <GlobalModal
        visible={orderVisible}
        onClose={() => setOrderVisible(prev => prev = false)}
        title="Записаться"
        content={<>
          <iframe className="yWidgetIFrame" frameBorder="0" allowTransparency={true} src={orderUrl}></iframe>
        </>} />
    </>
  )
}

export default observer(BranchPage)